import React from 'react'
import PropTypes from 'prop-types'
import Button from '../Button'
import './NewYearBanner.sass'
import Col from "../Col"
import Container from "../Container"

const NewYearBanner = ({path, text}) => {
  if (!text && !path){
    return null
  }
  return (
    <a className="NewYearBanner" href={path}>
      <Container>
        <Col xs={6} sm={12} md={24} lg={24}>
          <span className="NewYearBanner__btn-wrapper">
            <span className="NewYearBanner__decor" />
            <Button bsSize="large" >{text}</Button>
          </span>
        </Col>
      </Container>
    </a>
  )
}

NewYearBanner.propTypes = {
  path: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
}

export default NewYearBanner



// WEBPACK FOOTER //
// ./components/NewYearBanner/index.jsx